import { FC, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { App } from '@capacitor/app'

// Taken from https://capacitorjs.com/docs/guides/deep-links#react
const AppUrlListener: FC = () => {
  const history = useHistory()
  useEffect(() => {
    // Listens for an event if the app was opened with a url
    App.addListener('appUrlOpen', data => {
      const slug = data.url
      if (slug) {
        history.push(slug)
      }
      // If no match, do nothing - let regular routing
      // logic take over
    })
  }, [history])

  return null
}

export default AppUrlListener
